import './styles/SmartText.scss';


function SmartText() {


    return (
        <div className="smartText">
        <p className="desc2 black smartTextOne">
          <span className="subtitle upText colorGradientBlue dBlock">If it can be verified, it can be sold.</span>
          If it can be sold, there is a market value. If it has value, it
          can be modeled.
        </p>
        <p className="desc1 black smartTextOne">
          Paribus is the protocol that brings all of these forces
          together, offering DeFi holders and investors a platform to
          extend the reach of their digital assets and positions, doubling
          down on their earning power.
        </p>
      </div>
    )
}
            
export default SmartText;